import { render, staticRenderFns } from "./TranslateModel.vue?vue&type=template&id=4188e238"
import script from "./TranslateModel.vue?vue&type=script&lang=js"
export * from "./TranslateModel.vue?vue&type=script&lang=js"
import style0 from "./TranslateModel.vue?vue&type=style&index=0&id=4188e238&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports